module.exports = window["dokan"]["components"];